import { createAction, props } from '@ngrx/store';
import { DocumentSearchState } from '../../inventory/document-filter-form/document-filter-form.component';
import { HivelogDocumentType } from '../../inventory/document-type';
import { HivelogDocument } from '../../inventory/hivelog-document';

export const fetchDocuments = createAction(
  '[documents] fetch documents'
);
export const getDocumentsSuccess = createAction(
  '[documents] get documents success',
  props<{ documents: HivelogDocument[] }>()
);
export const getDocumentsError = createAction(
  '[documents] get documents failed',
  props<{ error: any }>()
);
export const updateTableFilter = createAction(
  '[documents] update table filter',
  props<{ tableFilter: DocumentSearchState }>()
);
export const fetchDocumentTypes = createAction(
  '[documents] fetch document types'
);
export const getDocumentTypesSuccess = createAction(
  '[documents] get document types success',
  props<{ documentTypes: HivelogDocumentType[] }>()
);
export const getDocumentTypesFail = createAction(
  '[documents] get document types failed'
);
